import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PersonApplicationService from "../../../../Services/PersonApplication.service";
import useService from "../../../Hooks/useService";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { AlertWarning } from "../../../UI/StandardAlerts/StandardAlerts";
import PersonApplicationCard from "../../../Presentational/PersonApplication/PersonApplicationCard";
const AdvisorStudentsStudentApplicationsTab = (props) => {
    const [applicationsState, loadApplications] = useService(PersonApplicationService.getApplications);
    React.useEffect(() => {
        loadApplications(props.student.affiliationId);
    }, [loadApplications, props.student.affiliationId]);
    return (_jsx(ServiceResult, { state: applicationsState, children: (applications) => applications.length > 0 ? (applications.map((application, index) => (_jsx("div", { className: "mb-3", children: _jsx(PersonApplicationCard, { personApplication: application, student: props.student }) }, index)))) : (_jsx(AlertWarning, { message: "There is no application data for this student" })) }));
};
export default AdvisorStudentsStudentApplicationsTab;
